import { render, staticRenderFns } from "./bimCheckbox.vue?vue&type=template&id=67a9da71&scoped=true&"
import script from "./bimCheckbox.vue?vue&type=script&lang=js&"
export * from "./bimCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./bimCheckbox.vue?vue&type=style&index=0&id=67a9da71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a9da71",
  null
  
)

export default component.exports